import apiClient from './apiClient';

export interface CuisineType {
  id: string;
  label: string;
  icon?: string;
}

export interface VenueSettingsPayload {
  name: string;
  brandColor: string;
  taxRate: number;
  serviceFee: number;
  kickoffAt?: string | null;
  walkSecPerSection: number;
  basePrepMin: number;
  sections?: string[] | null;
  cuisineTypes?: CuisineType[] | null;
}

class VenueSettingsService {
  async get(): Promise<VenueSettingsPayload> {
    return apiClient.get<VenueSettingsPayload>('/venue');
  }

  async update(data: Partial<VenueSettingsPayload>): Promise<VenueSettingsPayload> {
    return apiClient.put<VenueSettingsPayload>('/venue', data);
  }
}

const venueSettingsService = new VenueSettingsService();
export default venueSettingsService;
